// @flow strict
const PAGINATION = {
  PREV_PAGE: '← НАЗАД',
  NEXT_PAGE: '→ ВПЕРЕД'
};

export default PAGINATION;
